export default __webpack_public_path__ + "4af2a61192a3302116a88177a9d106fa.png";